import endpoints from 'constants/endpoints';

// the api rejects anything outside these bounds with a 400, so clamp before sending
const MIN_PAGE_SIZE = 1;
const MAX_PAGE_SIZE = 100;

export const FILES_PAGE_SIZE = 20;
// a smaller page reads better inside an expanded roster row
export const AGENT_FILES_PAGE_SIZE = 10;

function clampPage(page) {
  const parsed = Math.floor(Number(page));
  if (!Number.isFinite(parsed) || parsed < 1) return 1;
  return parsed;
}

function clampPageSize(pageSize) {
  const parsed = Math.floor(Number(pageSize));
  if (!Number.isFinite(parsed)) return FILES_PAGE_SIZE;
  return Math.min(Math.max(parsed, MIN_PAGE_SIZE), MAX_PAGE_SIZE);
}

function callReviewsFilesRoute() {
  // undefined for O'Neill: the endpoint only exists in the sunshine block
  return endpoints?.aws?.callReviewsFiles;
}

export const callReviewsKeys = {
  all: ['call-reviews-files'],
  // prefix for every roster/files page of the entry point, so it can be invalidated
  // without touching the per-agent queries
  overviewAll: () => [...callReviewsKeys.all, 'overview'],
  overview: (page, pageSize) => [
    ...callReviewsKeys.overviewAll(),
    page,
    pageSize
  ],
  agent: (agentId, page, pageSize) => [
    ...callReviewsKeys.all,
    'agent',
    agentId,
    page,
    pageSize
  ]
};

/**
 * request for the entry point, which answers with either view depending on the caller.
 * never send an agent/agency query param: a global middleware intercepts those keys.
 * @param page - 1-indexed page number
 * @param pageSize - rows per page, clamped to 1..100
 */
export function callReviewsOverviewRequest({ page, pageSize }) {
  return {
    path: callReviewsFilesRoute(),
    params: { page: clampPage(page), page_size: clampPageSize(pageSize) }
  };
}

/**
 * request for one agent's files, admin only. the agent id travels in the path,
 * never as a query param.
 * @param agentId - zoho agent id
 * @param page - 1-indexed page number
 * @param pageSize - rows per page, clamped to 1..100
 */
export function agentCallReviewsFilesRequest(agentId, { page, pageSize }) {
  return {
    path: `${callReviewsFilesRoute()}/agents/${encodeURIComponent(agentId)}`,
    params: { page: clampPage(page), page_size: clampPageSize(pageSize) }
  };
}
